export const parseJsonAttr = <T>(element: HTMLElement, attr: string, fallback: T): T => {
  const raw = element.getAttribute(attr);
  if (raw === null || raw === '') {
    return fallback;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};
